import { action, observable, computed } from 'mobx'
import { IGoodsCategory } from '../../../goods-storage/goods-library/modules/edit-goods/modules/model'
import { isExist } from '@/utils'

class StockSearchFilterStore {
    @observable
    category: IGoodsCategory | null = null

    @observable
    group: number[] = []

    @observable
    groupName: string = ''

    @computed
    get filterTxt() {
        const filterTxt = []

        if (this.category) {
            filterTxt.push(this.category.name)
        }
        if (this.groupName) {
            filterTxt.push(this.groupName)
        }

        return filterTxt.join('、')
    }

    @computed
    get filterQuery() {
        return {
            category_id: this.category ? this.category.id : void 0,
            group_id: this.group.length ? this.group[0] : void 0,
            secondary_group_id: isExist(this.group[1]) ? this.group[1] : void 0,
        }
    }

    @action
    setCategory(category: IGoodsCategory | null) {
        this.category = category
    }

    @action
    setGroup(group: number[], name: string) {
        this.group = group
        this.groupName = name
    }

    @action
    reset() {
        this.category = null
        this.group = []
        this.groupName = ''
    }
}

export const stockSearchFilterStore = new StockSearchFilterStore()
